import { BaseUnits } from "uom";
import * as UnitTimes from "../unit-times";
import { SquareMeter } from "./area";
/// Moment of inertia
export var KilogramSquareMeter = UnitTimes.massByArea("KilogramSquareMeter", BaseUnits.Kilogram, SquareMeter);
//# sourceMappingURL=moment-of-inertia.js.map